import ElTableColumn from './index.vue'

export default ElTableColumn
